export default '5.27.5';
